// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1U9z7","content":"GlobalSearch_content__1G0nE"};